import {
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
} from 'recharts';

import moment from 'moment';
import { isEmpty } from 'lodash';

import PercentageChange from 'components/PercentageChange';
import { currencyFormatter } from 'utils/formatters';
import ChartToolTip from 'components/Charts/ChartTooltip';

const UpsellAmount = ({ loading, records, summary }) => {
  return (
    <div className="bg-white p-4 mt-8">
      <div className="py-5">
        <div className="pb-5 pt-2 flex items-center justify-between">
          <p className="font-inter font-bold tracking-3/4 text-grayscale-900">
            MRR Upsell
          </p>

          {!isEmpty(summary) && (
            <div>
              <p className="font-inter leading-1.2 tracking-3/4 text-xl text-grayscale-900">
                {currencyFormatter(summary.upsoldAmount)}
              </p>

              <PercentageChange
                className="justify-end"
                currentValue={summary.upsoldAmount}
                previousValue={summary.previousUpsoldAmount}
              />
            </div>
          )}
        </div>
      </div>

      <div className="h-64">
        {loading ? (
          <div className="flex items-center justify-center h-full">
            <p className="text-2xl text-grayscale-700 animate-pulse tracking-2 leading-1.5 font-inter text-center items-center">
              Loading Data.....
            </p>
          </div>
        ) : (
          <ResponsiveContainer width={'100%'} height="100%" debounce={50}>
            <BarChart data={records}>
              <CartesianGrid stroke="#ECECEC" strokeDasharray="5 5" />
              <XAxis
                dataKey="startDate"
                style={{ fontSize: '11px', color: '#202020' }}
                tickFormatter={(date) => moment(date).format('MMM')}
              />

              <YAxis
                yAxisId="0"
                orientation="left"
                stroke="#8884d8"
                style={{ fontSize: '11px' }}
                tickFormatter={(value) => currencyFormatter(value)}
              />

              <Tooltip
                content={
                  <ChartToolTip
                    Title={({ payload }) => (
                      <p className="text-13 font-bold leading-1.5 text-grayscale-900">
                        {moment(payload[0].payload.startDate).format('MMM')}
                      </p>
                    )}
                  />
                }
              />

              <Bar
                yAxisId="0"
                stroke="#3BD7AD"
                fill="#3BD7AD"
                dataKey={'upsoldAmount'}
                dot={false}
                strokeWidth={3}
                name="Upsold Amount"
                formatter={currencyFormatter}
              />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

export default UpsellAmount;
